/* eslint-disable react-refresh/only-export-components */
import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const ProductOrderPage = lazy(
  () => import("@/pages/management/prdorder/ProductOrderPage"),
);
const ProductOrderLayout = lazy(
  () => import("@/pages/management/prdorder/ProductOrderLayout"),
);
const ProductOrderView = lazy(
  () => import("@/pages/management/prdorder/components/ProductOrderView"),
);

export const prdOrderRoutes: RouteObject[] = [
  {
    path: "/management/prdorder",
    element: <ProductOrderPage />,
    children: [
      {
        path: "domain/:domainId/site/:siteId",
        element: <ProductOrderLayout />,
        children: [
          {
            path: "",
            element: <ProductOrderView />,
          },
        ],
      },
    ],
  },
];
